import { Box, Checkbox, Grid, styled } from "@mui/material";
import ContentSection from "../../ContentSection";
import useHasTrust from "../../hooks/useHasTrust";
import LegalStatus from "./LegalStatus";
import PurchaseSale from "./PurchaseSale";
import PropertyTitle from "./PropertyTitle";
import useLoadField from "../../hooks/useLoadField";
import MxTypography from "@rf-l1/MxTypography";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";

const PropertyStatusLand = () => {
  const { HAS_TRUST_NO, HAS_TRUST_PENDING, HAS_TRUST_YES } = useHasTrust();
  const { hasTitleProperty, hasTitleTransfererToTrust } = useLoadField();
  const {
    validationDocuments: { trust_transferred_title, land_purchase, legal_status }
  } = useFormValidationsDocumentsMsgSlice();

  if (HAS_TRUST_YES && !hasTitleTransfererToTrust && !hasTitleProperty) return null;

  return (
    <ContentSection
      title="Estatus de propiedad del terreno"
      tooltip="Estatus de propiedad del terreno"
      color="grey"
      alert={
        trust_transferred_title?.alert || land_purchase?.alert || legal_status?.alert
      }
    >
      <Grid container item xs={12} spacing={2} p={2}>
        {(HAS_TRUST_NO || HAS_TRUST_PENDING) && (
          <>
            <LegalStatus />
            <PurchaseSale />
            <PropertyTitle />
          </>
        )}

        <Grid container item xs={12} spacing={2}>
          {hasTitleTransfererToTrust && (
            <Grid item xs={3}>
              <Disclaimer>
                <MxTypography variant="caption" color="white">
                  Tiene título transferido a fiduciaria
                </MxTypography>
                <CustomCheckbox checked={hasTitleTransfererToTrust} />
              </Disclaimer>
            </Grid>
          )}

          {hasTitleProperty && (
            <Grid item xs={3}>
              <Disclaimer>
                <MxTypography variant="caption" color="white">
                  Tiene título de propiedad
                </MxTypography>
                <CustomCheckbox checked={hasTitleProperty} />
              </Disclaimer>
            </Grid>
          )}
        </Grid>
      </Grid>
    </ContentSection>
  );
};

export default PropertyStatusLand;

const Disclaimer = styled(Box)`
  padding: 10px;
  background-color: var(--color-blue-main);
  font-size: 2px;
  padding: 10px 10px;
  font-weight: 400;
  display: flex;
  align-items: center;

  /* column-gap: 5px; */

  /* & span {
    font-weight: bold;
    margin-left: 2px;
    margin-right: 2px;
  } */
  border-radius: 20px;
`;

const CustomCheckbox = styled(Checkbox)`
  color: white;
  height: 20px;
  cursor: pointer;
  &.Mui-checked {
    color: white;
  }
`;
